/** @format */

import { useEffect } from "react";
import { PaperGroup } from "../hooks/usePaperQuestions";
import { PDFView } from "./PdfView";
import { useTranslation } from "react-i18next";

interface QuestionPreviewProps {
	onCancel: () => void;
	group: PaperGroup;
}
export const QuestionPreview = ({ onCancel, group }: QuestionPreviewProps) => {
	const { t } = useTranslation();

	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key === "Escape") {
				onCancel();
			}
		};
		document.addEventListener("keydown", handleKeyDown);
		return () => document.removeEventListener("keydown", handleKeyDown);
	}, [onCancel]);

	return (
		<>
			<button className="fixed inset-0 bg-black/15 z-40" onClick={onCancel} />
			<div
				role="alertdialog"
				aria-modal="true"
				aria-labelledby="question preview"
				className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 bg-white rounded-lg max-w-220.5 overflow-hidden border-(--public-color-paper-modal-border)"
			>
				<header className="flex flex-row items-center h-15.75 p-4 w-full gap-2 border-b border-(--public-color-border-filter)">
					<div className="flex flex-row items-center gap-2">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
							<path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
							<path
								fillRule="evenodd"
								d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z"
								clipRule="evenodd"
							/>
						</svg>
						<span className="font-roboto font-normal text-[20px] text-(--public-color-text-filter) leading-[150%] align-middle">
							{t("questionPreview.title")}
						</span>
					</div>
					<div className="ml-auto">
						<button aria-label="close question preview modal" onClick={onCancel} className="cursor-pointer">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								strokeWidth={2}
								stroke="#000000"
								className="size-6"
							>
								<path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
							</svg>
						</button>
					</div>
				</header>
				<div className="w-full h-100 overflow-y-auto">
					<PDFView groups={[group]} />
				</div>
				<footer className="flex h-15.75 border-t border-(--public-color-border-filter) p-3 gap-2 w-full justify-end">
					<button
						onClick={onCancel}
						className=" w-16.75 h-9.5 rounded-md py-1.5 px-3 border border-(--public-color-btn-filters-bg) font-roboto text-[16px] text-(--public-color-btn-filters-bg) leading-[150%] font-normal cursor-pointer"
					>
						{t("common.close")}
					</button>
				</footer>
			</div>
		</>
	);
};
